const SCROLL_EXTRA_OFFSET = 16;

type ScrollTarget = Window | HTMLElement;

const isScrollable = (element: HTMLElement) => {
  const { overflowY } = window.getComputedStyle(element);

  return (
    /(auto|scroll|overlay)/.test(overflowY) &&
    element.scrollHeight > element.clientHeight
  );
};

const getScrollTarget = (element: HTMLElement): ScrollTarget => {
  let current = element.parentElement;

  while (current) {
    if (isScrollable(current)) return current;
    current = current.parentElement;
  }

  return window;
};

const getStickyOffset = () => {
  const header = document.querySelector<HTMLElement>(".app-header");

  if (!header) return SCROLL_EXTRA_OFFSET;

  const { position } = window.getComputedStyle(header);

  if (position !== "sticky" && position !== "fixed") return SCROLL_EXTRA_OFFSET;

  return header.getBoundingClientRect().height + SCROLL_EXTRA_OFFSET;
};

const scrollPageToElement = (element: HTMLElement) => {
  const behavior: ScrollBehavior =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth";

  const target = getScrollTarget(element);
  const offset = getStickyOffset();
  const elementTop = element.getBoundingClientRect().top;

  const top =
    target === window
      ? elementTop + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset
      : elementTop -
        (target as HTMLElement).getBoundingClientRect().top +
        (target as HTMLElement).scrollTop -
        offset;

  const nextTop = Math.max(top, 0);

  if (typeof target.scrollTo === "function") {
    target.scrollTo({ top: nextTop, left: 0, behavior });
    return;
  }

  if (target !== window) (target as HTMLElement).scrollTop = nextTop;
};

export default scrollPageToElement;
